// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { Environment, REGEX } from '@ebeihilfe/core';

export const environment: Environment = {
  production: true,
  debugLevel: 'info',
  authentication: {
    grants: ['password'],
  },
  passwordRules: {
    minLength: 8,
    hitPointPerRule: 10,
    minHitPoints: 30,
    rules: [
      {
        name: 'small',
        pattern: REGEX.HAS_LOWERCASE,
        text: 'passwort_meter.rule_description.case_small',
      },
      {
        name: 'big',
        pattern: REGEX.HAS_UPPERCASE,
        text: 'passwort_meter.rule_description.case_big',
      },
      {
        name: 'numbers',
        pattern: REGEX.HAS_NUMBER,
        text: 'passwort_meter.rule_description.numbers',
      },
      {
        name: 'special',
        pattern: REGEX.HAS_SPECIAL,
        text: 'passwort_meter.rule_description.special',
      },
    ],
  },
  request: {
    hasCustomRequestStates: false,
    hasCustomRequestType: false,
  },
  customizing: {
    allowUserSelfDelete: true,
    hasUnfinishedAntrage: false,
    hasBescheide: true,
    hasUebersicht: true,
    ionic: {
      dashboard: {},
      scanbot: {
        documentScannerConfig: {
          primaryColor: '#871d33',
          secondaryColor: '#000000',
        },
        shouldBinarize: true,
        filter: 'PURE_BINARIZED',
      },
    },
    health: { timeout: 2000 },
  },
  pinConfiguration: {
    storage: 'persistent',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
